export default {
  switchEditor(state, editor) {
    setCurrentEditor(state, editor);
  },
  switchBackground(state, background) {
    setCurrentInlayBackground(state, background);
  },
  switchBackgroundImg(state, imgRef) {
    setCurrentInlayBackgroundImg(state, imgRef);
  },
  displayBackgroundImg(state, showImg) {
    setCurrentInlayShowImg(state, showImg);
  },
  selectBtns(state, selectedBtns) {
    setSelectedBtns(state, selectedBtns);
  },
  transformBgImg(state, transform) {
    setImgTransform(state, transform);
  },
  repositionBg(state, pos) {
    setBgPos(state, pos);
  },
  setLEDradius(state, rad) {
    setLEDrad(state, rad);
  },
  showLED(state, dLED) {
    setDisplayLed(state, dLED);
  },
  showBarG(state, dbarG) {
    setDisplayBarG(state, dbarG);
  },
  selectBarG(state, bargraph) {
    setSelectedBarG(state, bargraph);
  },
  setInlays(state, inlays) {
    setInlays(state, inlays);
  },
  setCurrentInlay(state, inlay) {
    setCurrentInlay(state, inlay);
  },
  setCurrentProjectName(state, name) {
    setCurrentProjectName(state, name);
  },
  setButtonStyle(state, button) {
    setButtonStyle(state, button);
  },
  saveInlay(state, inlay) {
    saveInlay(state, inlay);
  },
  showBarGCaptions(state, display) {
    setDisplayBarGCaptions(state, display);
  },
  addDraggableText(state) {
    setDraggableTexts(state);
  },
  draggingText(state, dragging) {
    setDraggingText(state, dragging);
  },
  setCurrentProject(state, project) {
    setCurrentProject(state, project);
  },
  addInlayToProject(state, inlay) {
    addInlayToProject(state, inlay);
  },
  removeInlayFromProject(state, inlay) {
    removeInlayFromProject(state, inlay);
  },
  setBargraphBackground(state, backgroundPayload) {
    setBargraphBackground(state, backgroundPayload);
  },
  setGtBackground(state, background) {
    setGtBackground(state, background);
  },
  setInlayName(state, name) {
    setInlayName(state, name);
  },
  setLastColor(state, color) {
    setLastUsedColor(state, color);
  },
  setDraggableTextCoord(state, draggable) {
    setDraggableTextCoord(state, draggable);
  },
  setSelectedText(state) {
    setSelectedText(state);
  },
  setDraggableTextContent(state, draggable) {
    setDraggableTextContent(state, draggable);
  },
  updateProjectInlay(state) {
    updateProjectInlay(state);
  },
  setCurrentInlayIndex(state, index) {
    setCurrentInlayIndex(state, index);
  },
  changeInlayKeys(state) {
    setInlayKeysDimensions(state);
  },
  setMoveTexts(state, value) {
    setMoveTexts(state, value);
  },
  setBargraphCaptionContent(state, caption) {
    changeBargraphContent(state, caption);
  },
  emptySaveInlay(state) {
    setSaveInlay(state);
  },
  selectLED(state, led) {
    selectLED(state, led);
  },
  hideSelectedLEDs(state) {
    hideSelectedLEDs(state);
  },
  displayLEDs(state, display) {
    displayLEDs(state, display);
  },
  changeOrientation(state, newDim) {
    changeOrientation(state, newDim);
  },
  setSmallKeys(state, value) {
    setSmallKeys(state, value);
  },
  setRevertKeys(state, value) {
    revertKeys(state, value);
  },
  setSelectedBarGLEDsEmpty(state) {
    setSelectedBarGLEDsEmpty(state);
  },

  changeGT2TOrientation(state, newDim) {
    changeGT2TOrientation(state, newDim);
  },

  switchGT6L(state, payload) {
    setCurrentGT6LInlay(state, payload);
  },
  switchGT6LBackgroundImg(state, payload) {
    setGT6LBackgroundImg(state, payload);
  },
  changeGT12Orientation(state, newDim) {
    changeGT12Orientation(state, newDim);
  },
  setBarGCaptionsRightDown(state) {
    setBarGCaptionsRightDown(state);
  },
  setBarGCaptionsAlternating(state) {
    setBarGCaptionsAlternating(state);
  },
  setBarGCaptionsLeftUp(state) {
    setBarGCaptionsLeftUp(state);
  },
  setBarGCaptionColor(state, payload) {
    setBarGCaptionColor(state, payload);
  },
};
function setBarGCaptionColor(state, payload) {
  for (let bgled in state.currentInlay.inlay.bargraph) {
    state.currentInlay.inlay.bargraph[bgled].caption.style.color = payload;
  }
  console.log(state.currentInlay.inlay);
}
function setBarGCaptionsRightDown(state) {
  state.currentInlay.inlay.bargraphCaptionsAlternating = false;
  if (state.currentInlay.inlay.style.horizontal) {
    for (let bgled in state.currentInlay.inlay.bargraph) {
      if (
        parseInt(state.currentInlay.inlay.bargraph[bgled].caption.content) %
          2 !=
        0
      )
        state.currentInlay.inlay.bargraph[bgled].caption.style.top =
          parseFloat(
            state.currentInlay.inlay.bargraph[
              bgled
            ].caption.style.top.substring(
              0,
              state.currentInlay.inlay.bargraph[bgled].caption.style.top
                .length - 2
            )
          ) +
          6.65 +
          "mm";
    }
  } else {
    for (let bgled in state.currentInlay.inlay.bargraph) {
      if (
        parseInt(state.currentInlay.inlay.bargraph[bgled].caption.content) %
          2 !=
        0
      )
        state.currentInlay.inlay.bargraph[bgled].caption.style.left =
          parseFloat(
            state.currentInlay.inlay.bargraph[
              bgled
            ].caption.style.left.substring(
              0,
              state.currentInlay.inlay.bargraph[bgled].caption.style.left
                .length - 2
            )
          ) +
          6 +
          "mm";
    }
  }
}
function setBarGCaptionsLeftUp(state) {
  state.currentInlay.inlay.bargraphCaptionsAlternating = false;
  if (state.currentInlay.inlay.style.horizontal) {
    for (let bgled in state.currentInlay.inlay.bargraph) {
      if (
        parseInt(state.currentInlay.inlay.bargraph[bgled].caption.content) %
          2 ==
        0
      )
        state.currentInlay.inlay.bargraph[bgled].caption.style.top =
          parseFloat(
            state.currentInlay.inlay.bargraph[
              bgled
            ].caption.style.top.substring(
              0,
              state.currentInlay.inlay.bargraph[bgled].caption.style.top
                .length - 2
            )
          ) -
          5.35 +
          "mm";
    }
  } else {
    for (let bgled in state.currentInlay.inlay.bargraph) {
      if (
        parseInt(state.currentInlay.inlay.bargraph[bgled].caption.content) %
          2 ==
        0
      )
        state.currentInlay.inlay.bargraph[bgled].caption.style.left =
          parseFloat(
            state.currentInlay.inlay.bargraph[
              bgled
            ].caption.style.left.substring(
              0,
              state.currentInlay.inlay.bargraph[bgled].caption.style.left
                .length - 2
            )
          ) -
          6 +
          "mm";
    }
  }
}
function setBarGCaptionsAlternating(state) {
  state.currentInlay.inlay.bargraphCaptionsAlternating = true;
  if (state.currentInlay.inlay.style.horizontal) {
    for (let bgled in state.currentInlay.inlay.bargraph) {
      if (
        parseInt(state.currentInlay.inlay.bargraph[bgled].caption.content) %
          2 !=
        0
      )
        state.currentInlay.inlay.bargraph[bgled].caption.style.top =
          40.65 + "mm";
      else
        state.currentInlay.inlay.bargraph[bgled].caption.style.top =
          46.65 + "mm";
    }
  } else {
    for (let bgled in state.currentInlay.inlay.bargraph) {
      if (
        parseInt(state.currentInlay.inlay.bargraph[bgled].caption.content) %
          2 !=
        0
      )
        state.currentInlay.inlay.bargraph[bgled].caption.style.left =
          state.currentInlay.name.includes("gt12")
            ? 40.65 + "mm"
            : 16.15 + "mm";
      else
        state.currentInlay.inlay.bargraph[bgled].caption.style.left =
          state.currentInlay.name.includes("gt12")
            ? 46.65 + "mm"
            : 22.15 + "mm";
    }
  }
}
function setCurrentEditor(state, editor) {
  state.currentEditor = editor;
}
function setSelectedBarGLEDsEmpty(state) {
  state.selectedBarGLEDs = [];
}
//TODO: diese funktionen und die anderen background funktionen zusammenfügen/abstrahieren über Parameter!!!
function setCurrentInlayBackground(state, bgcolor) {
  if (!state.currentInlay.name.includes("gt6l"))
    state.currentInlay.inlay.style["background-color"] = bgcolor;
  else
    state.currentInlay.inlay[state.selectedGT6LInlay].style[
      "background-color"
    ] = bgcolor;
}

function setCurrentInlayBackgroundImg(state, imgRef) {
  state.currentInlay.inlay.style["background-image"] = imgRef;
}
function setImgTransform(state, transform) {
  state.currentInlay.inlay.style["background-size"] = transform;
}
function setBgPos(state, pos) {
  state.currentInlay.inlay.style["background-position"] = pos;
}

function setCurrentInlayShowImg(state, showImg) {
  state.currentInlay.showImg = showImg;
}

function setSelectedBtns(state, selected) {
  state.selectedBtns = selected;
}

function setLEDrad(state, rad) {
  if (!state.currentInlay.name.includes("gt6l"))
    state.currentInlay.inlay.ledRad = rad;
  else {
    state.currentInlay.inlay[state.selectedGT6LInlay].ledRad = rad;
  }
}
function setDisplayLed(state, dLED) {
  if (!state.currentInlay.name.includes("gt6l")) {
    state.currentInlay.inlay.showLEDs = dLED;
  } else {
    state.currentInlay.inlay[state.selectedGT6LInlay].showLEDs = dLED;
  }
}
function setInlays(state, inlays) {
  state.parsedInlays = inlays;
}
function setCurrentInlay(state, inlay) {
  state.currentInlay = inlay;
}
function setCurrentProjectName(state, name) {
  state.currentProjectName = name;
}
function setDisplayBarG(state, dbarG) {
  state.currentInlay.inlay.showBargraph = dbarG;
}
function setSelectedBarG(state, bargraph) {
  state.selectedBarG = bargraph;
  state.currentInlay.inlay.selectedBarGType = bargraph[0].type;
}
function setButtonStyle(state, button) {
  if (!state.currentInlay.name.includes("gt6l"))
    state.currentInlay.inlay.btns[button.index].style.image[button.style] =
      button.value;
  else {
    state.currentInlay.inlay[state.selectedGT6LInlay].btns[
      button.index
    ].style.image[button.style] = button.value;
  }
}
function saveInlay(state, inlay) {
  state.inlaySave.push(inlay);
}
function setDisplayBarGCaptions(state, display) {
  state.currentInlay.inlay.showBargraphCaptions = display;
}
function setDraggableTexts(state) {
  let newText = {
    top: 5 + "mm",
    left: 40 + "mm",
    id: Math.floor(Math.random() * (100 - 1) + 1),
    content: "Text",
    style: {
      "font-size": "",
      "font-family": "",
      color: "",
      "font-weight": "",
      "font-style": "",
      "text-decoration": "",
      transform: "",
    },
    editable: false,
  };
  if (!state.currentInlay.name.includes("gt6l"))
    state.currentInlay.inlay.draggableTexts.push(newText);
  else
    state.currentInlay.inlay[state.selectedGT6LInlay].draggableTexts.push(
      newText
    );
}
function setDraggingText(state, dragging) {
  state.draggingText = dragging;
}
function setCurrentProject(state, project) {
  state.currentProject = project;
}
function addInlayToProject(state, inlay) {
  state.currentProject.push(inlay);
}
function removeInlayFromProject(state, inlay) {
  if (state.currentProject.length > 1) {
    state.currentProject.splice(inlay, 1);
  } else {
    state.currentProject.pop();
  }
}
function setBargraphBackground(state, payload) {
  state.currentInlay.inlay.bargraph[payload.index].style["background-color"] =
    payload.color;
}
function setGtBackground(state, payload) {
  state.currentInlay.gtBackground = payload;
}
function setInlayName(state, name) {
  state.currentInlay["project-name"] = name;
  //console.log("new name", state.currentInlay["project-name"]);
}
function setLastUsedColor(state, color) {
  state.lastColor = color;
}
function setDraggableTextCoord(state, draggable) {
  if (!state.currentInlay.name.includes("gt6l")) {
    state.currentInlay.inlay.draggableTexts[draggable.index].top =
      draggable.top;
    state.currentInlay.inlay.draggableTexts[draggable.index].left =
      draggable.left;
  } else {
    state.currentInlay.inlay[state.selectedGT6LInlay].draggableTexts[
      draggable.index
    ].top = draggable.top;
    state.currentInlay.inlay[state.selectedGT6LInlay].draggableTexts[
      draggable.index
    ].left = draggable.left;
  }
}
function updateProjectInlay(state) {
  state.currentProject[state.currentInlayIndex] = state.currentInlay;
}
function setCurrentInlayIndex(state, index) {
  state.currentInlayIndex = index;
}
function setSelectedText(state) {
  state.selectedTexts = [];
}
function setInlayKeysDimensions(state) {
  let btns = state.currentInlay.inlay.btns;
  let len;
  if (btns.length % 2 == 0) len = btns.length;
  else len = btns.length - 1;
  for (let i = 0; i < len; i++) {
    if (state.currentInlay.inlay.style.width == "62.3mm") {
      btns[i].style.width = "22.5mm";
      if (i % 2 != 0) btns[i].style.left = "50.7mm";
    } else {
      btns[i].style.height = "22.5mm";
      if (i % 2 != 0) btns[i].style.top = "50.7mm";
    }
  }
  state.currentInlay.inlay.btns = btns;
}
function setDraggableTextContent(state, draggable) {
  state.currentInlay.inlay.draggableTexts[draggable.index].content =
    draggable.text;
}
function setMoveTexts(state, value) {
  state.moveTexts = value;
}
function changeBargraphContent(state, caption) {
  state.currentInlay.inlay.bargraph[caption.id].caption.content =
    caption.content;
}
function setSaveInlay(state) {
  state.inlaySave = [];
}
function selectLED(state, led) {
  state.selectedLEDs.push(led);
}
function hideSelectedLEDs(state) {
  state.selectedLEDs.forEach((led) => {
    if (!state.currentInlay.name.includes("gt6l"))
      state.currentInlay.inlay.leds[led].style.display = "none";
    else {
      state.currentInlay.inlay[state.selectedGT6LInlay].leds[
        led
      ].style.display = "none";
    }
  });
  state.selectedLEDs = [];
}
function displayLEDs(state, display) {
  if (!state.currentInlay.name.includes("gt6l")) {
    state.currentInlay.inlay.leds.forEach((led) => {
      led.style.display = display;
    });
  } else {
    state.currentInlay.inlay[state.selectedGT6LInlay].leds.forEach((led) => {
      led.style.display = display;
    });
  }
}

//TODO: REWORK THIS!
function changeOrientation(state, newDim) {
  state.currentInlay.gtDim.topHeight = newDim.gtDim.lWidth;
  state.currentInlay.gtDim.botHeight = newDim.gtDim.rWidth;
  state.currentInlay.gtDim.lWidth = newDim.gtDim.topHeight;
  state.currentInlay.gtDim.rWidth = newDim.gtDim.botHeight;
  state.currentInlay.gtDim.height = newDim.gtDim.width;
  state.currentInlay.gtDim.width = newDim.gtDim.height;
  state.currentInlay.inlay[state.selectedGT6LInlay].style.horizontal =
    !state.currentInlay.inlay[state.selectedGT6LInlay].style.horizontal;

  for (let inlay in state.currentInlay.inlay) {
    for (let btn in newDim.btns[inlay]) {
      state.currentInlay.inlay[inlay].btns[btn].style.top =
        newDim.btns[inlay][btn].style.left;
      state.currentInlay.inlay[inlay].btns[btn].style.left =
        newDim.btns[inlay][btn].style.top;
      state.currentInlay.inlay[inlay].btns[btn].style.height =
        newDim.btns[inlay][btn].style.width;
      state.currentInlay.inlay[inlay].btns[btn].style.width =
        newDim.btns[inlay][btn].style.height;
    }
    state.currentInlay.inlay[inlay].style.top = newDim.inlayDim.left;
    state.currentInlay.inlay[inlay].style.left = newDim.inlayDim.top;
    state.currentInlay.inlay[inlay].style.height = newDim.inlayDim.width;
    state.currentInlay.inlay[inlay].style.width = newDim.inlayDim.height;
  }

  for (let btn in state.currentInlay.preview.btns) {
    state.currentInlay.preview.btns[btn].style.top =
      newDim.preBtns[btn].style.left;
    state.currentInlay.preview.btns[btn].style.left =
      newDim.preBtns[btn].style.top;
    state.currentInlay.preview.btns[btn].style.height =
      newDim.preBtns[btn].style.width;
    state.currentInlay.preview.btns[btn].style.width =
      newDim.preBtns[btn].style.height;
  }
  for (let led in state.currentInlay.inlay[state.selectedGT6LInlay].leds) {
    state.currentInlay.inlay[state.selectedGT6LInlay].leds[led].style.top =
      newDim.leds[led].style.left;
    state.currentInlay.inlay[state.selectedGT6LInlay].leds[led].style.left =
      newDim.leds[led].style.top;
  }
}
function changeGT2TOrientation(state, newDim) {
  state.currentInlay.inlay.style.top = newDim.inlayDim.left;
  state.currentInlay.inlay.style.left = newDim.inlayDim.top;
  state.currentInlay.inlay.style.height = newDim.inlayDim.width;
  state.currentInlay.inlay.style.width = newDim.inlayDim.height;
  state.currentInlay.inlay.style.horizontal =
    !state.currentInlay.inlay.style.horizontal;

  for (let btn in state.currentInlay.inlay.btns) {
    state.currentInlay.inlay.btns[btn].style.top = newDim.btns[btn].style.left;
    state.currentInlay.inlay.btns[btn].style.left = newDim.btns[btn].style.top;
    state.currentInlay.inlay.btns[btn].style.height =
      newDim.btns[btn].style.width;
    state.currentInlay.inlay.btns[btn].style.width =
      newDim.btns[btn].style.height;
  }
  for (let led in state.currentInlay.inlay.leds) {
    if (newDim.leds[led].style.left == "20mm" && (led == 0 || led == 2)) {
      state.currentInlay.inlay.leds[led].style.top = "65.75mm";
      state.currentInlay.inlay.leds[led].style.left =
        newDim.leds[led].style.top;
    } else if (led == 1 || led == 3) {
      state.currentInlay.inlay.leds[led].style.top =
        newDim.leds[led].style.left;
      state.currentInlay.inlay.leds[led].style.left =
        newDim.leds[led].style.top;
    } else if (
      newDim.leds[led].style.top == "65.75mm" &&
      (led == 0 || led == 2)
    ) {
      state.currentInlay.inlay.leds[led].style.top =
        newDim.leds[led].style.left;
      state.currentInlay.inlay.leds[led].style.left = "20mm";
    }
  }
}
function changeGT12Orientation(state, newDim) {
  state.currentInlay.gtDim.topHeight = newDim.gtDim.lWidth;
  state.currentInlay.gtDim.botHeight = newDim.gtDim.rWidth;
  state.currentInlay.gtDim.lWidth = newDim.gtDim.topHeight;
  state.currentInlay.gtDim.rWidth = newDim.gtDim.botHeight;
  state.currentInlay.gtDim.height = newDim.gtDim.width;
  state.currentInlay.gtDim.width = newDim.gtDim.height;
  state.currentInlay.inlay.style.horizontal =
    !state.currentInlay.inlay.style.horizontal;

  state.currentInlay.inlay.style.top = newDim.inlayDim.left;
  state.currentInlay.inlay.style.left = newDim.inlayDim.top;
  state.currentInlay.inlay.style.height = newDim.inlayDim.width;
  state.currentInlay.inlay.style.width = newDim.inlayDim.height;

  for (let btn in state.currentInlay.inlay.btns) {
    state.currentInlay.inlay.btns[btn].style.top = newDim.btns[btn].style.left;
    state.currentInlay.inlay.btns[btn].style.left = newDim.btns[btn].style.top;
    state.currentInlay.inlay.btns[btn].style.height =
      newDim.btns[btn].style.width;
    state.currentInlay.inlay.btns[btn].style.width =
      newDim.btns[btn].style.height;
  }
  for (let led in state.currentInlay.inlay.leds) {
    state.currentInlay.inlay.leds[led].style.top = newDim.leds[led].style.left;
    state.currentInlay.inlay.leds[led].style.left = newDim.leds[led].style.top;
  }
  for (let bgled in state.currentInlay.inlay.bargraph) {
    state.currentInlay.inlay.bargraph[bgled].style.top =
      newDim.bargraph[bgled].style.left;
    state.currentInlay.inlay.bargraph[bgled].style.left =
      newDim.bargraph[bgled].style.top;
    state.currentInlay.inlay.bargraph[bgled].caption.style.top =
      newDim.bargraph[bgled].caption.style.left;
    state.currentInlay.inlay.bargraph[bgled].caption.style.left =
      newDim.bargraph[bgled].caption.style.top;
  }
}
function setSmallKeys(state, value) {
  state.smallKeys = value;
}
function revertKeys(state, gtDetail) {
  let originalInlay = state.parsedInlays[gtDetail.group].filter(
    (inlay) => inlay.name == gtDetail.name
  );
  for (let btn in state.currentInlay.inlay.btns) {
    state.currentInlay.inlay.btns[btn].style.top =
      originalInlay[0].inlay.btns[btn].style.top;
    state.currentInlay.inlay.btns[btn].style.left =
      originalInlay[0].inlay.btns[btn].style.left;
    state.currentInlay.inlay.btns[btn].style.height =
      originalInlay[0].inlay.btns[btn].style.height;
    state.currentInlay.inlay.btns[btn].style.width =
      originalInlay[0].inlay.btns[btn].style.width;
  }
}
function setCurrentGT6LInlay(state, payload) {
  state.selectedGT6LInlay = payload;
}
function setGT6LBackgroundImg(state, payload) {
  for (let btn in state.selectedBtns) {
    state.currentInlay.inlay[state.selectedGT6LInlay].btns[btn].style[
      "background-image"
    ] = payload;
  }
}
